// Port 1:1 da assets/js/map-legend.js (v1 resta la fonte di verità per la
// parità; non divergere).
//
// Globali browser richiesti (caricati via <script> PRIMA di importare questo
// modulo, come in v1):
// - window.WSPalettes (assets/js/map-palettes.js, sovrascrivibile da
//   assets/data/palettes.json) — registro centrale delle palette; le scale
//   che ritorna sono funzioni chroma (map-palettes.js richiede chroma.js).
// NB: come in v1, breaks/colors della pioggia sono letti dal registro UNA
// volta al load del modulo; le scale di getColorScale sono invece late-bound.

// Mappa parametro->scala centralizzata nel registro window.WSPalettes.
// (map-legend.js:1721)
export function getColorScale(parametro) {
    return window.WSPalettes.scaleForParam(parametro);
}

// (map-legend.js:1709-1710)
const rain_value = window.WSPalettes.registry.pioggia.colors;
const rainBreaks = window.WSPalettes.registry.pioggia.breaks;

// Scala a intervalli discreti: ritorna direttamente la stringa colore
// (NON un oggetto chroma). (map-legend.js:1885)
function makeIntervalScaler(breaks, colors){
    return function(v){
        if (!Number.isFinite(v)) return colors[0];
        if (v <= breaks[0]) return colors[0];
        for (let i=0;i<breaks.length-1;i++){
            if (v < breaks[i+1]) return colors[i+1];
        }
        return colors[colors.length-1];
    }
}
export const rainIntervalColor = makeIntervalScaler(rainBreaks, rain_value);
